export const ZoomInValue = 2;

export const ZoomOutValue = 0.2;

export const DefaultZoomValue = 0.2;

export const edgeDefault = 0;
